import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { MarketingEntryPoint } from "@redotech/redo-model/advanced-flow/schemas/marketing/marketing";
import {
  CustomerCustomFieldDataType,
  customerCustomFieldValueSchema,
} from "@redotech/redo-model/customer-custom-fields/customer-custom-fields-definition";

export const signupFormDataSchema = z.object({
  email: z.string().optional(),
  phone: z.string().optional(),
  birthday: z.date().optional(),
  customFields: z
    .array(
      z.object({
        declarationId: z.string(),
        dataType: createEnum(CustomerCustomFieldDataType),
        value: customerCustomFieldValueSchema,
      }),
    )
    .optional(),
});
export type SignupFormData = z.infer<typeof signupFormDataSchema>;

export enum SignupFormLocation {
  CUSTOMER_PORTAL = "customer_portal",
  SHOPIFY_STOREFRONT = "shopify_storefront",
  COMMENTSOLD_STOREFRONT = "commentsold_storefront",
}

// email or phone number
export const submitSignupFormStepSchema = {
  name: "submitSignupFormStep" as const,
  input: z.object({
    formId: z.string(),
    stepIndex: z.number(),
    formData: signupFormDataSchema,
    customerId: z.string().nullable().optional(),
    entryPoint: createEnum(MarketingEntryPoint),
    anonymousId: z.string().optional(),
    treatmentId: zExt.objectId().nullish(),
    // TODO: (@javaroc): Remove nullish and default once front-end is updated to send this field.
    location: createEnum(SignupFormLocation, { enumName: "SignupFormLocation" })
      .nullish()
      .transform((value) => value ?? SignupFormLocation.SHOPIFY_STOREFRONT),
  }),
  // Not returning customerId for security reasons.
  output: z.object({
    success: z.boolean(),
    error: z.string().optional(),
    discountCode: z.string().optional(),
  }),
};
